import {Component} from '@angular/core'
@Component({
    selector:"qrmena-cashier-index",
    templateUrl:'./cashier-index.component.html',
    styleUrls:['./cashier-index-compomnent.css']
})
export class CashierIndexComponent{

}


// WEBPACK FOOTER //
// ./src/QrMena/cashier/cashier-index-component/cashier-index.component.ts